import React, {PropsWithChildren} from 'react';
import classnames from 'classnames';

import {EARNINGS_TAB} from '../utils';

interface Props {
  currentTab: string;
  changeTab: React.Dispatch<React.SetStateAction<string>>;
}

const Header = ({currentTab, changeTab}: Props) => (
  <div className="portfolio-sidebar-header">
    <div className="portfolio-sidebar-header-tabs">
      <Tab tabName={EARNINGS_TAB} currentTab={currentTab} onChangeTab={changeTab}>
        Earnings
      </Tab>
    </div>
  </div>
);

interface TabProps extends PropsWithChildren {
  tabName: string;
  currentTab: string;
  onChangeTab: React.Dispatch<React.SetStateAction<string>>;
}

const Tab = ({tabName, currentTab, onChangeTab, children}: TabProps) => (
  <button
    type="button"
    className={classnames('portfolio-sidebar-header-tab', {selected: currentTab === tabName})}
    onClick={() => onChangeTab(tabName)}
  >
    {children}
  </button>
);

export default Header;
